import { ChangeDetectorRef, Directive, OnDestroy, OnInit } from '@angular/core';
import { getBuildIdQuery, IBrandId, ILink } from '@ncg/data';
import { Subject, takeUntil } from 'rxjs';
import { SettingsService } from '../core/settings.service';
import { NavigationService } from '../navigation/navigation.service';

@Directive() // Using directive decorator to fix DI errors.
export class BaseFooterController implements OnInit, OnDestroy {
    private readonly unsubscribe = new Subject<void>();

    public readonly buildIdQuery = getBuildIdQuery();
    public readonly logoLink: ILink = {
        isExternal: false,
        name: '',
        url: '/',
    };

    public brandId?: IBrandId;
    public isFrontPage = false;

    constructor(
        private readonly cd: ChangeDetectorRef,
        public readonly navigationService: NavigationService,
        public readonly settingsService: SettingsService
    ) {}

    public ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    public ngOnInit(): void {
        this.settingsService
            .get()
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((settings) => {
                this.brandId = settings.brandId;
                this.cd.markForCheck();
            });

        this.navigationService
            .isFrontPage()
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((data) => {
                this.isFrontPage = data;
                this.cd.markForCheck();
            });
    }
}
